import { render, staticRenderFns } from "./ReferenceManage.vue?vue&type=template&id=564d8499&"
import script from "./ReferenceManage.vue?vue&type=script&lang=js&"
export * from "./ReferenceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports